import jwt_decode from 'jwt-decode'
import * as Sentry from "@sentry/browser";
import store from '@vue/store';

const EUROCHANGE_COMMERCE_TOKEN = 'eurochange_commerce_token'

/**
 * Sets (or clears) tags relating to the cart/order in sentry context
 * @param {string|null} token - The jwt
 */
const setSentryTags = (token) => {
  const payload = token ? jwt_decode(token) : {};

  Sentry.setTag('commerce.cartId', payload['ice:cart_id']);
  Sentry.setTag('commerce.orderId', payload['ice:order_id']);
}

export const getToken = async () => {
  let token = await store.dispatch('session/getToken');
  return token;
}

export const saveToken = token => {
  setSentryTags(token);
  window.localStorage.setItem(EUROCHANGE_COMMERCE_TOKEN, token)
}

export const hasBearerToken = () => {
  return !!window.localStorage.getItem(EUROCHANGE_COMMERCE_TOKEN)
}

export const hasExpiredBearerToken = async () => {
  if (!hasBearerToken()) {
    return false;
  }

  const expiry = await getBearerTokenExpiryUnixTimestamp();
  const nowUnixTime = Math.floor(Date.now() / 1000);
  const diff = expiry - nowUnixTime;

  return diff <= 0;
}

const getBearerTokenExpiryUnixTimestamp = async () => {
  if (!hasBearerToken()) {
    return null
  }

  const expiry = jwt_decode(await getToken())['exp']
  return parseInt(expiry)
}

export const deleteBearerToken = () => {
  setSentryTags(null);
  window.localStorage.removeItem(EUROCHANGE_COMMERCE_TOKEN)
}

export const hasExpiredToken = (token) => {
  const expiry = parseInt(jwt_decode(token)['exp']);
  const nowUnixTime = Math.floor(Date.now() / 1000);
  const diff = expiry - nowUnixTime;

  return diff <= 0;
}

export default { getToken, saveToken, hasBearerToken, hasExpiredBearerToken, deleteBearerToken, hasExpiredToken }
